module.exports = __webpack_public_path__ + "static/media/slide9.649f77d9.jpg";